import produce from 'immer';

import * as myOrderTypes from '../../../actions/myOrders/myOrderTypes';

const initState = {
  isLoading: false,
  data: null,
};

const pastOrdersReducer = (state = initState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
    case myOrderTypes.GET_PAST_ORDERS:
      draft.isLoading = true;
      break;

    case myOrderTypes.GET_PAST_ORDERS_SUCCESS:
      draft.isLoading = false;

      draft.data = action.payload;
      break;

    case myOrderTypes.GET_PAST_ORDERS_FAILED:
      draft.isLoading = false;
      break;
    }

    return draft;
  });

export default pastOrdersReducer;
